import { Outlet } from "react-router";
import { BrandMark, useBranding } from "../lib/branding";

export function AuthLayout() {
  const { productName } = useBranding();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-gradient-to-b from-brand-50 to-slate-50 px-4 py-10">
      <div className="mb-6 flex items-center gap-2">
        <BrandMark className="size-10" />
        <span className="text-xl font-semibold tracking-tight">{productName}</span>
      </div>
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
        <Outlet />
      </div>
    </div>
  );
}
